import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Row,
  Col,
} from "reactstrap";

import { useToasts } from "react-toast-notifications";
import { postMethod } from "../../services/httpServices";
import SearchableSelect from "components/dropdown/SearchDropdown";

const EditNFC = (props) => {
  const [values, setValues] = React.useState({ customerId: "" });
  const [loading, setLoading] = React.useState(false);
  const [customers, setCustomers] = React.useState([]);
  const [isAssigned, setIsAssigned] = useState(true);
  const { addToast } = useToasts();

  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCustomers = async () => {
    let errorMsg = "";
    setLoading(true);
    postMethod("/api/Subscriber/Customers", {}, "get")
      .then((res) => {
        setLoading(false);
        if (res && res.data) {
          if (res.data.responseCode === "200" && res.data.result) {
            // Success
            if (!res.data.result || !res.data.result.length) {
              res.data.result = [];
            }
            setCustomers(res.data.result);
          } else if (res.data.responseCode === "400") {
            // Error
            errorMsg = res.data.responseMessage || "Error in fetching list";
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = "Unknown Error in fetching";
            notifyFailed(errorMsg);
          }
        } else {
          errorMsg = "Unknown Error";
          notifyFailed(errorMsg);
        }
      })
      .catch((err) => {
        setLoading(false);
        notifyFailed("Something went wrong!, Please call 3737");
      });
  };

  const notifyFailed = (text) => {
    if (!text) {
      text = "Error in saving";
    }
    addToast(text, {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const notifySuccess = (text) => {
    if (!text) {
      text = "Save successfully";
    }
    addToast(text, {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const closeModal = () => {
    props.closeModal();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!values.customerId) {
      setIsAssigned(false);
      return;
    } else {
      setIsAssigned(true);
    }
    e.preventDefault();
    const payload = {
      ...props?.values,
      customerName: customers.find((i) => i.id === Number(values.customerId))
        ?.fullName,
      customerId: Number(values.customerId),
    };
    let errorMsg = "";
    setLoading(true);
    postMethod("/api/Subscriber/SmartPayCard/Update ", payload, "post")
      .then((res) => {
        setLoading(false);
        if (res && res.data) {
          if (res.data.responseCode === "200") {
            notifySuccess("Updated Successfully");
            closeModal();
          } else if (res.data.responseCode === "400") {
            // Error while saving
            errorMsg = res.data.responseMessage || "Error while saving";
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = "Unknown Error in saving";
            notifyFailed(errorMsg);
          }
        } else {
          // Not valid response from server
          errorMsg = "Unknown Error";
          notifyFailed(errorMsg);
        }
      })
      .catch((err) => {
        setLoading(false);
        errorMsg = "Something went wrong!, Please call 3737";
        notifyFailed(errorMsg);
      });
  };

  return (
    <div className="p-0">
      <Row>
        <Col xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="8">
                  <h3 className="mb-0">Assign NFC</h3>
                </Col>
                <Col className="text-right" xs="4">
                  <Button
                    color="primary"
                    onClick={closeModal}
                    size="xs"
                    close
                    // className="fa fa-times"
                    style={{ cursor: "pointer", fontSize: "25px" }}
                  ></Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="pl-lg-4">
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label
                          for="input-customerId"
                          className="form-control-label"
                        >
                          Customer
                        </label>
                        <br />
                        <SearchableSelect
                          options={customers
                            .filter(
                              (i) =>
                                !i.isDeleted &&
                                !i.isBlocked &&
                                i.verificationStatus === "Verified"
                            )
                            ?.map((i) => ({
                              key: i?.id,
                              value: i?.fullName,
                            }))}
                          dropdownVersion={2}
                          onSelect={(e) =>
                            setValues({ ...values, customerId: e.key })
                          }
                        />
                        <br />
                        {!isAssigned && (
                          <label className="text-red text-sm">
                            Please select customer
                          </label>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <Button
                  type="submit"
                  color="primary"
                  className="mt-4 float-right"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EditNFC;
